<div class="">
  <div *ngIf="definition.url" class="d-flex justify-content-between align-items-end">
    <div [translate]="'banner.addLinksInfo'" class="ad-banner-editor__info-text">Add links by selecting an area</div>
    <div class="mb-2" *ngIf="definition.url">
      <button type="button" class="btn btn-outline-primary" (click)="removeImage()" [translate]="'banner.removeImage'">
        Remove image
      </button>
    </div>
  </div>
  <div class="ad-banner-editor d-flex justify-content-center">
    <div *ngIf="!definition.url" class="d-flex flex-column justify-content-center align-items-center">
      <div *ngIf="descriptionKey" class="ad-banner-editor__info-text-internal">
        {{descriptionKey | translate}}
      </div>
      <ng-container *ngIf="!uploading">
        <input
          #fileUpload
          type="file"
          (change)="uploadImage($event)"
          style="display: none;"
          accept="image/*"
          ngf-max-size="1MB"
        />
        <button (click)="fileUpload.click()" class="btn btn-primary" type="button">
          {{'banner.upload' | translate}}
        </button>
      </ng-container>
      <div *ngIf="uploading && uploadProgress < 100" class="ad-banner-editor__progress-bar">
        <ngb-progressbar [value]="uploadProgress" class="active" type="info"></ngb-progressbar>
      </div>
      <div *ngIf="uploading && uploadProgress >= 100">
        <svg-icon icon="spinner-large"></svg-icon>
      </div>
    </div>

    <div
      *ngIf="definition.url"
      class="ad-banner-editor__img-container"
      (mousedown)="onMouseDown($event)"
      (mouseup)="onMouseUp()"
      (mousemove)="onMouseMove($event)"
    >
      <img #bannerImage [src]="definition.url" class="ad-banner-editor__img" />

      <ng-container *ngIf="definition.clickMap.length === clickMapStyles.length">
        <selection-area
          *ngFor="let clickArea of definition.clickMap; let $index = index; let $last = last;"
          [top]="clickMapStyles[$index].top"
          [left]="clickMapStyles[$index].left"
          [width]="clickMapStyles[$index].width"
          [height]="clickMapStyles[$index].height"
          [mouseMove]="mouseMoveObservable"
          (onUpdate)="onClickAreaUpdated($index, $event)"
          (onDelete)="deleteClickArea($index)"
          [activeHandle]="$last && handleForLastClickArea ? handleForLastClickArea : undefined"
          [url]="clickArea.url"
        >
        </selection-area>
      </ng-container>
    </div>
  </div>
</div>
